import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
const stack = [{
  item: 'Yoga Teacher System™',
  primary: true
}, {
  item: '120 Complete Ready-to-Teach Classes',
  primary: true
}, {
  item: '6 Professional Volumes'
}, {
  item: '20 Classes Per Volume'
}, {
  item: '40+ Weeks of Teaching Material'
}, {
  item: 'Complete Class Structures'
}, {
  item: '5 Premium Bonus Resources'
}, {
  item: 'Instant Digital Access'
}];
export function OfferSection() {
  return <section id="offer" className="w-full bg-ivory py-10 sm:py-14 lg:py-20" aria-labelledby="offer-heading" data-id="element-131" data-mp="mgwiz74g7qe0">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-132" data-mp="wcrbctyh4ztz">
        <div className="rounded-[2rem] border border-gold/50 bg-cream p-1.5 shadow-card" data-id="element-133" data-mp="wawwnxdsq3yc">
          <div className="rounded-[1.7rem] border border-gold/25 bg-ivory px-4 py-7 sm:px-8 sm:py-9" data-id="element-134" data-mp="2t742sn19j2ow">
            <div className="mx-auto max-w-2xl text-center" data-id="element-135" data-mp="2y4mdoiyubrzj">
              <div className="flex justify-center" data-id="element-136" data-mp="12ojzklxzckqi">
                <SectionLabel data-id="element-137" data-mp="12pd0356cie07">The complete offer</SectionLabel>
              </div>
              <h2 id="offer-heading" className="mt-3 font-serif text-[1.5rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-138" data-mp="xvh0jyafoj2x">
                Everything you get today
              </h2>
            </div>

            <ul className="mx-auto mt-5 grid max-w-xl gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-139" data-mp="1llbgwptyoprx">
              {stack.map(({
              item,
              primary
            }) => <li key={item} className="flex items-center justify-center gap-2.5 rounded-xl bg-cream/70 px-3 py-2.5 text-center" data-id="element-140" data-mp="1gl6ukj6dh0ts">
                  <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-forest" data-id="element-141" data-mp="17mbr3eupq4u6">
                    <CheckIcon className="h-2.5 w-2.5 text-ivory" aria-hidden="true" data-id="element-142" data-mp="14g95d70zts2" />
                  </span>
                  <span className={`text-[0.82rem] leading-snug sm:text-[0.9rem] ${primary ? 'font-semibold text-ink' : 'text-muted'}`} data-id="element-143" data-mp="3sf6t31khiify">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-7 border-t border-gold/25 pt-7 text-center" data-id="element-144" data-mp="3oude3xae2uec">
              <span className="inline-block rounded-full bg-forest px-4 py-1.5 text-[0.55rem] font-semibold uppercase tracking-label text-ivory" data-id="element-145" data-mp="3b3i2wecf417l">
                Today
              </span>
              <p className="mt-3 font-serif text-[3.5rem] font-semibold leading-none text-forest sm:text-7xl" data-id="element-146" data-mp="3fw1g3a770ubv">
                $19{' '}
                <span className="align-baseline text-[0.4em] font-semibold uppercase tracking-label text-ink" data-id="element-147" data-mp="363vlrttgy0ti">
                  USD
                </span>
              </p>
              <p className="mt-3 text-[0.8rem] leading-snug text-muted sm:text-sm" data-id="element-148" data-mp="2x3qsenl412yc">
                Pay in your local currency.
              </p>
              <p className="mt-3 flex items-center justify-center gap-2 text-[0.62rem] font-semibold uppercase tracking-label text-ink" data-id="element-149" data-mp="2diq9pkeob2x2">
                <span className="h-px w-6 bg-gold/50" aria-hidden="true" data-id="element-150" data-mp="28kyg8lydr8qr" />
                One-time payment · No subscription
                <span className="h-px w-6 bg-gold/50" aria-hidden="true" data-id="element-151" data-mp="2ih9wfn13ciqh" />
              </p>

              <div className="mt-6" data-id="element-152" data-mp="2wgjdeox4fgvi">
                <CtaButton href="https://yogateachersystem.impultienda.ar/checkout" label="Get Yoga Teacher System™ now" microcopy="Instant Digital Access • One-Time Purchase" data-id="element-153" data-mp="2wfrjdij69r7c" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}